export enum enumCompanyPartnershipType {
  GENERAL_PARTNERSHIP = 1,
  LIMITED_PARTNERSHIP = 2,
  LIMITED_LIABILITY_PARTNERSHIP = 3,
}
